// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".App .middle .document .image-div{width:100%;max-width:400px;margin:0 20px}.App .middle .document .image-div .document-image{width:100%}\n", ""]);
// Exports
module.exports = exports;
